import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-list-view-toggle',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './list-view-toggle.component.html',
  styleUrls: ['./list-view-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // TODO: animation
})
export class ListViewToggleComponent {
  // TODO: Need to implement the name and value
  stdColor1 = '171';
  stdColor2 = '169';
  @Input() listViews: ListView[] = [
    {
      name: 'List',
      iconPath: 'assets/images/icons/typography/list.svg#list',
      value: 'list',
    },
    {
      name: 'Grid',
      iconPath: 'assets/images/icons/layouts/grid-2x2.svg#grid-2x2',
      value: 'grid_view',
    },
  ];
  @Input() selected: ViewType = 'list';
  @Output() selectedChange = new EventEmitter<ViewType>();

  onViewChange(viewValue: ViewType) {
    this.selected = viewValue;
    this.selectedChange.emit(viewValue);
  }
}

export type ViewType = 'list' | 'grid_view';

export interface ListView {
  name: string;
  iconPath: string;
  value: ViewType;
}
